<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M0 8a8 8 0 1 0 7.992-8A8 8 0 0 0 0 8z" style="fill:#fdb525" fill="currentColor"/><path d="M0 .154c1.881 0 2.992-1.133 2.992-2.464a2.249 2.249 0 0 0-1.639-2.211L.286-4.972C-.407-5.247-.99-5.456-.99-6.039c0-.539.462-.858 1.177-.858a2.6 2.6 0 0 1 1.727.671l.825-1.023A3.612 3.612 0 0 0 .187-8.294 2.539 2.539 0 0 0-2.629-5.94a2.358 2.358 0 0 0 1.65 2.189l1.089.462c.726.308 1.221.5 1.221 1.1 0 .572-.451.935-1.3.935a3.2 3.2 0 0 1-2.068-.9l-.933 1.12A4.338 4.338 0 0 0 0 .154z" style="fill:#fff" transform="translate(8 12)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-suggest',
});
</script>
